<template>
    <div class="sidebar-container">
        <sidebar-item
            :data-title="$t('message.sidebar.message.overview')"
            :data-link="generalVisionRedirectUrl"
            data-icon="mdi-home-outline"
        >
        </sidebar-item>

        <sidebar-item
            v-if="!isDisabledModuleHidden('READ_STATISTICS')"
            :data-title="$t('message.sidebar.message.statistics')"
            :data-link="statistcsRedirectUrl"
            data-icon="mdi-poll"
            :disabled="!canReadStatics"
            v-tooltip="{
                content:
                    !canReadStatics && isMaster
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                classes: 'custom-tooltip',
            }"
        ></sidebar-item>

        <sidebar-toggle
            :title="$t('message.sidebar.message.registrations')"
            icon="mdi-account-outline"
        >
            <sidebar-item
                v-if="!isDisabledModuleHidden('READ_LEADS')"
                :data-title="$t('message.generics.message.accesses')"
                :data-link="accessRedirectUrl"
                :disabled="!canReadLeads"
                v-tooltip="{
                    content:
                        !canReadLeads && isMaster
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
            ></sidebar-item>

            <sidebar-item
                :data-title="$t('message.sidebar.message.imports')"
                :data-link="importsRedirectUrl"
                :disabled="!canReadLeads"
                v-tooltip="{
                    content:
                        !canReadLeads && isMaster
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
            ></sidebar-item>
        </sidebar-toggle>

        <sidebar-item
            :data-title="$t('message.sidebar.message.campaigns')"
            data-link="/campanhas"
            data-icon="mdi-bullhorn-outline"
            :disabled="!canReadCampaign"
            v-tooltip="{
                content:
                    !canReadCampaign && isMaster
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                classes: 'custom-tooltip',
            }"
        ></sidebar-item>

        <sidebar-item
            v-if="!isDisabledModuleHidden('CREATE_SURVEY_FORM')"
            :data-title="$t('message.sidebar.message.survey')"
            :data-link="surveyRedirectUrl"
            data-icon="list-box-outline"
            is-compiled-icon
            :disabled="!canCreateSurveyForm"
            v-tooltip="{
                content:
                    !canCreateSurveyForm && isMaster
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                classes: 'custom-tooltip',
            }"
        ></sidebar-item>

        <sidebar-toggle
            v-if="!isMarketingHidden"
            :title="$t('message.sidebar.message.marketing')"
            icon="mdi-send"
        >
            <sidebar-item
                v-tooltip="{
                    content: !canUseMarketingModule
                        ? $t('message.sidebar.message.marketingNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
                :disabled="!canUseMarketingModule"
                :data-title="$t('message.generics.message.email')"
                :data-link="emailRedirectUrl"
            ></sidebar-item>

            <sidebar-item
                v-tooltip="{
                    content: !canUseMarketingModule
                        ? $t('message.sidebar.message.marketingNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
                :disabled="!canUseMarketingModule"
                :data-title="$t('message.generics.message.sms')"
                :data-link="smsRedirectUrl"
            ></sidebar-item>

            <sidebar-item
                v-tooltip="{
                    content: !canUseMarketingModule
                        ? $t('message.sidebar.message.marketingNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
                :disabled="!canUseMarketingModule"
                :data-title="$t('message.sidebar.message.automation')"
                :data-link="automationRedirectUrl"
            ></sidebar-item>

            <sidebar-item
                v-tooltip="{
                    content: !canUseMarketingModule
                        ? $t('message.sidebar.message.marketingNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
                :disabled="!canUseMarketingModule"
                :data-link="whatsRedirectUrl"
                data-title="WhatsApp"
            ></sidebar-item>
        </sidebar-toggle>

        <sidebar-item
            :data-title="$t('message.sidebar.message.comments')"
            :data-link="commentsRedirectUrl"
            data-icon="mdi-comment-text"
            :disabled="!canReadComments"
            v-tooltip="{
                content:
                    !canReadComments && isMaster
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                classes: 'custom-tooltip',
            }"
        ></sidebar-item>

        <sidebar-toggle
            v-if="canUseDataWifi"
            :title="$t('message.sidebar.message.monitoring')"
            icon="mdi-clipboard-pulse-outline"
        >
            <sidebar-item
                :data-title="$t('message.sidebar.message.heatMap')"
                :disabled="!canUseDataWifi"
                v-tooltip="{
                    content:
                        !canUseDataWifi && isMaster
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
                @click="redirectToDataWifiHeatMap"
            ></sidebar-item>

            <sidebar-item
                :data-title="$t('message.sidebar.message.external')"
                :disabled="!canUseDataWifi"
                v-tooltip="{
                    content:
                        !canUseDataWifi && isMaster
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
                @click="redirectToDataWifiExternal"
            ></sidebar-item>

            <sidebar-item
                :data-title="'Tráfego'"
                :data-link="trafficRedirectUrl"
                :disabled="!canUseDataWifi"
                v-tooltip="{
                    content:
                        !canUseDataWifi && isMaster
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
            ></sidebar-item>
        </sidebar-toggle>

        <sidebar-item
            v-if="!isDisabledModuleHidden('USE_BILLING_MODULE')"
            :data-title="$t('message.sidebar.message.billing')"
            :data-link="billingRedirectUrl"
            data-icon="billing"
            is-compiled-icon
            :disabled="!canManageBilling"
            v-tooltip="{
                content: !canManageBilling
                    ? $t('message.generics.message.funcionalityNotActive')
                    : '',
            }"
        ></sidebar-item>

        <sidebar-item
            v-if="!isDisabledModuleHidden('MANAGE_CONNECTIONS')"
            :data-title="$t('message.sidebar.message.connections')"
            :data-link="conectionsRedirectUrl"
            data-icon="mdi-lan-connect"
            :disabled="!canManagerConnections"
            v-tooltip="{
                content:
                    !canManagerConnections && isMaster
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                classes: 'custom-tooltip',
            }"
        ></sidebar-item>

        <sidebar-toggle
            v-if="!isDisabledModuleHidden('MANAGE_USERS')"
            title="Auditoria"
            icon="mdi-clipboard-text-outline"
            :disabled="!canManageUsers"
            v-tooltip="{
                content: !canManageUsers
                    ? $t('message.generics.message.funcionalityNotActive')
                    : '',
                classes: 'custom-tooltip',
            }"
        >
            <sidebar-item
                data-title="Registros de Acessos"
                :data-link="auditAccessLogsRedirectUrl"
                :disabled="!canManageUsers"
            ></sidebar-item>

            <sidebar-item
                data-title="Auditoria de Ações"
                :data-link="auditActionLogsRedirectUrl"
                :disabled="!canManageUsers"
            ></sidebar-item>

            <sidebar-item
                data-title="Acesso Patrocinado"
                :data-link="auditSponsoredAccessRedirectUrl"
                :disabled="!canManageUsers"
            ></sidebar-item>
        </sidebar-toggle>
<sidebar-toggle
            v-if="isWhitelabelScreensVisible || !isMarketingHidden"
            :title="$t('message.sidebar.message.platformCustomization')"
            icon="mdi-monitor-dashboard"
        >
            <sidebar-item
                v-if="isWhitelabelScreensVisible"
                :data-title="$t('message.sidebar.message.platformDomain')"
                :data-link="whitelabelDomainRedirectUrl"
                :disabled="!canUseWhitelabel"
                v-tooltip="{
                    content: !canUseWhitelabel
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="isWhitelabelScreensVisible"
                :data-title="$t('message.sidebar.message.platformScreens')"
                :data-link="whitelabelScreensRedirectUrl"
                :disabled="!canUseWhitelabel"
                v-tooltip="{
                    content: !canUseWhitelabel
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isMarketingHidden"
                :data-title="$t('message.sidebar.message.systemEmails')"
                :data-link="systemEmailsRedirectUrl"
                :disabled="!canUseMarketingModule"
                v-tooltip="{
                    content: !canUseMarketingModule
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>
        </sidebar-toggle>
        <sidebar-toggle
            :title="$t('message.generics.message.settings')"
            icon="mdi-settings"
        >
            <sidebar-item
                :data-title="$t('message.generics.message.general')"
                :data-link="generalConfigRedirectUrl"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isDisabledModuleHidden('MANAGE_AUTHENTICATION')"
                data-title="Gerenciamento de Autenticação"
                :data-link="authManagamentRedirectUrl"
                :disabled="!canManageAuthentication"
                v-tooltip="{
                    content:
                        !canManageAuthentication 
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isDisabledModuleHidden('MANAGE_MAC_POLICY')"
                data-title="Política de Acesso"
                :data-link="accessPolicyRedirectUrl"
                :disabled="!canManageMacPolicy"
                v-tooltip="{
                    content:
                        !canManageMacPolicy 
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isDisabledModuleHidden('MANAGE_USERS')"
                :data-title="$t('message.generics.message.users')"
                :data-link="usersRedirectUrl"
                :disabled="!canManageUsers"
                v-tooltip="{
                    content:
                        !canManageUsers && isMaster
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isDisabledModuleHidden('READ_LOCALS')"
                :data-title="$t('message.generics.message.spots')"
                :data-link="localsRedirectUrl"
                :disabled="!canManageLocals"
                v-tooltip="{
                    content:
                        !canManageLocals && isMaster
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isDisabledModuleHidden('MANAGE_INTEGRATIONS')"
                :data-title="$t('message.settings.message.integrations')"
                :data-link="integrationsRedirectUrl"
                :disabled="!canManageIntegration"
                v-tooltip="{
                    content:
                        !canManageIntegration && isMaster
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isDisabledModuleHidden('MANAGE_PLATFORM_API')"
                :data-title="$t('message.settings.message.api')"
                :data-link="apisRedirectUrl"
                :disabled="!canManageApi"
                v-tooltip="{
                    content:
                        !canManageApi && isMaster
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isDisabledModuleHidden('CUSTOMIZE_USE_TERMS')"
                :data-title="$t('message.settings.message.termsOfUse')"
                :data-link="termsRedirectUrl"
                :disabled="!canCusomizeUsageTerms"
                v-tooltip="{
                    content: !canCusomizeUsageTerms
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isDisabledModuleHidden('CUSTOMIZE_CAPTIVE_PAGE')"
                :data-title="$t('message.settings.message.captiveEdit')"
                :data-link="loginPersonalizeUrl"
                :disabled="!canCustomizeCaptivePage"
                v-tooltip="{
                    content:
                        !canCustomizeCaptivePage && isMaster
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isDisabledModuleHidden('CUSTOMIZE_CAPTIVE_PAGE')"
                :data-title="'Tela de Bloqueio'"
                :data-link="blockScreenRedirectUrl"
                data-icon=""
                :disabled="!canCustomizeCaptivePage"
                v-tooltip="{
                    content: !canCustomizeCaptivePage
                        ? $t('message.generics.message.funcionalityNotActive')
                        : '',
                }"
            ></sidebar-item>

            <sidebar-item
                :data-title="$t('message.settings.message.captiveForms')"
                :data-link="captiveFormsRedirectUrl"
            >
            </sidebar-item>

            <sidebar-item
                v-if="!isDisabledModuleHidden('ALLOW_TRACKERS')"
                :data-title="$t('message.trackers.message.trackers')"
                :disabled="!canManageTrackers"
                v-tooltip="{
                    content:
                        !canManageTrackers && isMaster
                            ? $t(
                                  'message.generics.message.funcionalityNotActive'
                              )
                            : '',
                    classes: 'custom-tooltip',
                }"
                :data-link="trackersUrl"
            >
            </sidebar-item>

            <sidebar-item
                data-title="Vouchers"
                :data-link="vouchersRedirectUrl"
            >
            </sidebar-item>

            <sidebar-item
                :data-title="$t('message.settings.message.setBusinessHours')"
                :data-link="businessHoursRedirectUrl"
            ></sidebar-item>
        </sidebar-toggle>
    </div>
</template>

<script>
import SidebarItem from "@components/generic/sidebar/item/SidebarItem";
import SidebarToggle from "@components/generic/sidebar/toggle/SidebarToggle";
import provider from "@packages/mixins/provider";
import { redirectUtils } from "@packages/util/redirect/redirectUtils";

export default {
    components: {
        SidebarItem,
        SidebarToggle,
    },

    data() {
        return {
            showingSmsModal: false,
            entity: "establishment",
            isShowingTrackersModal: false,
        };
    },
    mixins: [provider],

    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    methods: {
        isDisabledModuleHidden(permission) {
            return !this.permissions.includes(permission) && this.hideDisabledModules;
        },
        openTrackersModal() {
            this.isShowingTrackersModal = true;
        },
        async redirectToDataWifiHeatMap() {
            try {
                const redirectUrl =
                    await this.$api.dataWifi.getHeatMapRedirectUrl();
                window.open(redirectUrl, "_blank");
            } catch (error) {
                console.log(error);
            }
        },
        redirectToDataWifiExternal() {
            window.open(
                "https://app.datawifi.co/easyfi/web/app.php/login",
                "_blank"
            );
        },
    },

    computed: {
        usersRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/usuarios');
        },
        authManagamentRedirectUrl( ) {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/autenticacao');
        },
        accessPolicyRedirectUrl( ) {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/politica-de-acesso');
        },
        integrationsRedirectUrl( ) {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/integracoes');
        },
        generalConfigRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/geral');
        },
        importsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/cadastros/importacoes');
        },
        accessRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/cadastros/acessos');
        },
        whatsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/marketing/whatsapp');
        },
        smsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/marketing/sms');
        },
        emailRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/marketing/email');
        },
        automationRedirectUrl() {
        return redirectUtils.mountUrl('/new/estabelecimento/marketing/automacao');
    },       
        surveyRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/pesquisa');
        },

        billingRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/bilhetagem');
        },

        captiveFormsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/cadastros/formularios');
        },

        loginPersonalizeUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/cadastros/tela');
        },

        trackersUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/rastreadores');
        },

        commentsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/comentarios');
        },

        conectionsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/conexoes');
        },

        blockScreenRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/tela-de-bloqueio');
        },

        businessHoursRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/horario');
        },

        apisRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/apis');
        },

        vouchersRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/vouchers');
        },       

        termsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/termos-de-uso');
        },

        whitelabelScreensRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/personalizacao/telas');
        },

        whitelabelDomainRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/personalizacao/dominio');
        },

        systemEmailsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/comunicacoes');
        },

        localsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/configuracoes/locais');
        },

        generalVisionRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/visao-geral');
        },

        statistcsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/estatisticas');
        },

        trafficRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/monitoramento/trafego');
        },

        auditAccessLogsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/auditoria/registro-de-acessos');
        },

        auditActionLogsRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/auditoria/auditoria-de-acoes');
        },

        auditSponsoredAccessRedirectUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/auditoria/acesso-patrocinado');
        },

        permissions() {
            return this.user.permissions;
        },
        canReadStatics() {
            return !!this.permissions.find((x) => x === "READ_STATISTICS");
        },
        canReadLeads() {
            return !!this.permissions.find(
                (permission) => permission === "READ_LEADS"
            );
        },
        canManagerConnections() {
            return !!this.permissions.find((x) => x === "MANAGE_CONNECTIONS");
        },
        canReadCampaign() {
            return !!this.permissions.find((x) => x === "READ_CAMPAIGN");
        },
        canCreateSurveyForm() {
            return !!this.permissions.find((x) => x === "CREATE_SURVEY_FORM");
        },
        canUseDataWifi() {
            return !!this.permissions.find((x) => x === "DATAWIFI_REDIRECT");
        },
        canReadComments() {
            return !!this.permissions.find((x) => x === "READ_COMMENTS");
        },
        canUseMarketingModule() {
            return this.permissions.find((x) => x === "USE_MARKETING_MODULE");
        },
        canManageLocals() {
            return this.permissions.find((x) => x == "MANAGE_LOCALS");
        },
        canManageAuthentication() {
            return this.permissions.find((x) => x == "MANAGE_AUTHENTICATION");
        },
        canManageMacPolicy() {
            return this.permissions.find((x) => x == "MANAGE_MAC_POLICY");
        },
        canManageUsers() {
            return (
                this.permissions.find((x) => x == "MANAGE_USERS") ||
                this.permissions.find((x) => x == "MASTER")
            );
        },
        canManageBilling() {
            return !!this.permissions.find((x) => x === "USE_BILLING_MODULE");
        },
        canManageIntegration() {
            return this.permissions.find((x) => x == "MANAGE_INTEGRATIONS");
        },
        canCustomizeCaptivePage() {
            return this.permissions.find((x) => x == "CUSTOMIZE_CAPTIVE_PAGE");
        },
        canCusomizeUsageTerms() {
            return this.permissions.find((x) => x == "CUSTOMIZE_USE_TERMS");
        },
        canManageTrackers() {
            return this.permissions.find((x) => x == "ALLOW_TRACKERS");
        },
        canManageApi() {
            return this.permissions.find((x) => x == "MANAGE_PLATFORM_API");
        },
        canUseWhitelabel() {
            return this.permissions.includes("USE_WHITELABEL");
        },
        isWhitelabelScreensVisible() {
            return (
                this.isMaster && !this.isDisabledModuleHidden("USE_WHITELABEL")
            );
        },
        isMaster() {
            return this.permissions.includes("MASTER");
        },
        hideDisabledModules() {
            return this.permissions.includes("HIDE_DISABLED_MODULES");
        },
        isMarketingHidden() {
            return this.isDisabledModuleHidden("USE_MARKETING_MODULE");
        },
    },
};
</script>

<style lang="scss">
.sidebar-container {
    a {
        text-decoration: none;
    }
}

.custom-tooltip {
    margin-right: -325px;

    .tooltip-arrow {
        margin-left: -70px;
    }
}
</style>
